export const SELECTION_KEY = 'account-dataset-entitlements';

export const SECTION_NAME = 'Dataset Entitlements';

export const NO_ASSIGNED_ENTITLEMENT_TITLE = 'There are no dataset entitlements assigned to this account.';
